import { LoginManager } from "./LoginManager"
import { MqttClient } from "@/lib/MqttClient";
import { IPasswordData, IUser, IUserWithToken } from "@/../../server/src/user/IUser";
import { RouterHistory } from "@/router/RouterHistory";
import { ObjEvents } from "@/../server/src/mqtt/ObjEvents";
import { user_api } from "@/user/IUserSvc";

export interface IConcurrent {
  type: string, id: string, user_name: string, who_asked_to_close: string, date: Date
}

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    Bus: Bus;
    localStorage:any;
    user:any;
    router_history:RouterHistory;
    mqtt_client: any
  }
}


interface IRet {
  error:number
  text:string
  obj:any
}

export interface IBus {
  api(url: string, obj: any):any
  fire(event: string, detail:any):any
  remove(event: string, callback: any):any
  register(event: string, callback: any):any
  set_token(token:string):any
}

export default class Bus implements IBus {
  _bus: any;
  last: any = {};

  constructor() {
    
  }
    
  public tree_open_date: Date|undefined = undefined
  BASE:string = "";
  public static calls:number=0;
  public static spin_callback:any = undefined
  static current_path:string=""
  
  public static set_current_path(path: string) {
    this.current_path = path
  }

  public static get_current_path() {
    return this.current_path
  }

  public static set_spin_callback(spin_callback: any) {
    this.spin_callback = spin_callback
  }


  public static lock() {
    Bus.calls++
    console.log("Bus.lock ", Bus.calls)
    //if (Bus.spin_callback) Bus.spin_callback(Bus.calls)
    //console.log("after lock. calls:",Bus.calls)
  }


  public static unlock() {
    Bus.calls--
    console.log("Bus.unlock ", Bus.calls)
    //if (Bus.spin_callback) Bus.spin_callback(Bus.calls)
    //console.log("after unlock. calls:",Bus.calls)
  }

  getBus() {
    if (!window.Bus) {
      this._bus = document.createElement("div");
      window.Bus = this;
      console.log("App mqtt client set")
      const w = <any> Window;
      w.mqtt_client = new MqttClient(this)
      w.mqtt_client.connect()
      console.log("********************* BUS CREATE")
      return window.Bus;
    } else {
      
      return window.Bus;
    }
  }

async delay(ms: number) {
    await new Promise(resolve => setTimeout(resolve, ms));
}


  async before_path_change(from_path: string, to_path: string) {
    console.log("Concurrent", from_path, to_path)
    const parts = to_path.split('/');
    const obj = parts[1]
    const id = parts[2]
    if (obj == "technologie" && id) {
      
        await this.delay(1000);
        this.tree_open_date = new Date()
        const obj: IConcurrent = 
        {
            type: "technologie", 
            id:id, 
            user_name: this.get_user().data_username, 
            date: this.tree_open_date,
            who_asked_to_close: ""
        }
        await this.get_mqtt_client().publish(ObjEvents.event_path_open, JSON.stringify(obj))
    }
}

async send_close_request(obj: IConcurrent) {
  const curr_path = Bus.get_current_path()
  const curr_parts = curr_path.split('/');
  const curr_obj = curr_parts[1]
  const curr_id = curr_parts[2]

  if (curr_id && curr_obj=="technologie") {
      if (curr_id == obj.id && curr_obj == obj.type) {
          const date = this.tree_open_date ? new Date(this.tree_open_date) : new Date()
          console.log( this.get_user().data_username,  )
          console.log("date", date, obj.date, date.getTime() < new Date(obj.date).getTime())

          if (obj.user_name != this.get_user().data_username && new Date(date).getTime() < new Date(obj.date).getTime() ) {
            obj.who_asked_to_close = this.get_user().data_username
            await this.get_mqtt_client().publish(ObjEvents.event_path_close_request, JSON.stringify(obj))
            return false;
          }
      }
  }
  return true;
}


 process_close_request(obj: IConcurrent) {
    const curr_path = Bus.get_current_path()
    const curr_parts = curr_path.split('/');
    const curr_obj = curr_parts[1]
    const curr_id = curr_parts[2]

    if (curr_id && curr_obj=="technologie") {
        if (curr_id == obj.id && curr_obj == obj.type) {
            if (obj.user_name == this.get_user().data_username) {
              alert("Użytkownik "+obj.who_asked_to_close+" wprowadza tu zmiany. Niestety nie możesz teraz korzystać z tej funkcjonalności." )
              window.router.push({ path: `/technologie/` }) 
              return false;
            }
        }
    }
    return true;
}



  get_mqtt_client() {
    const w = <any> Window;
    return w.mqtt_client
  }

  register_insert_handler(callback: any) {
    this._bus.addEventListener(ObjEvents.event_insert, callback);
  }

  register_update_handler(callback: any) {
    this._bus.addEventListener(ObjEvents.event_update, callback);
  }

  register_delete_handler(callback: any) {
    this._bus.addEventListener(ObjEvents.event_delete, callback);
  }

  remove_insert_handler(callback: any) {
    this._bus.removeEventListener(ObjEvents.event_insert, callback);
  }

  remove_update_handler(callback: any) {
    this._bus.removeEventListener(ObjEvents.event_update, callback);
  }

  remove_delete_handler(callback: any) {
    this._bus.removeEventListener(ObjEvents.event_delete, callback);
  }

  register(event: string, callback: any) {
    this._bus.addEventListener(event, callback);
    if (this.last[event]) {
      //callback(this.last[event]); powoduje endless loop in Finder
    }
  }

  remove(event: string, callback: any) {
    this._bus.removeEventListener(event, callback);
  }

  fire(event: string, detail = {}) {
    console.log("bus.fire",event,  detail )
    this._bus.dispatchEvent(new CustomEvent(event, { detail }));
    this.last[event] = detail;
  }


  set_user(user:IUser | undefined) {
    console.log("set_user", user)
    alert("set user"+JSON.stringify(user))
    //window.user = user
    if (user == undefined) {
      this.on_logout()
    }
    if (user != undefined) { 
      this.on_login(user)
    }
  }

  get_user():IUser {
    //const user = window.user
    const u=window.localStorage.getItem("user")
    const user = JSON.parse(u)
//    console.log("get_user", user)
    return user
  }

  set_token(token:string) {
  //  console.log("set_token", token)
    window.localStorage.setItem("token",token)
  }

  get_token():string {
    const token = window.localStorage.getItem("token")
    //console.log("get_token", token)
    return token
  }

  async wait_completed() {
    //console.log("wait_completed start")
    while (Bus.calls) { 
      document.body.style.cursor = 'wait';
      await this.sleep(200);
      //console.log("wait_completed: calls=", Bus.calls)
    }
    //console.log("wait_completed end")
    document.body.style.cursor = 'default';
  }

  
  async sleep(milliseconds:number) {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }
  

  async call(url: string, obj: any) {

    console.log("Bus.call", url, "calls:",Bus.calls)
    obj.token=this.get_token();
    //if (!obj.token && url!= "/api/user/login") this.fire("login_needed")

    const body:string = JSON.stringify(obj)

    console.log(">>>>> BUS CALL:",this.BASE+url, obj)
    //console.log("url",this.BASE+url)
    console.log("params:",  '{ method: "POST",  headers: {  Accept: "application/json",  "Content-Type": "application/json" }')
    //console.log("body:", body)

    Bus.lock()
    const rawResponse = await fetch(this.BASE+url, { method: "POST",  headers: {  Accept: "application/json",  "Content-Type": "application/json" },body: body });
    Bus.unlock()

    if (rawResponse.status >= 400) {
      console.error(">>>>> BUS ERR :",url, "HTTP Status > 400")
      throw "Bład API"
    }

 
    const content = await rawResponse.json();
    //console.log("A",content,"B", content.status)

    

   
    if (content.login_err) {
      delete content.token;
      delete obj.token;
      this.set_token("")
      this.on_method_call_timeout()
      return undefined;
    }


    if (url!= "/api/user/login") { 
      delete content.token;
      delete obj.token;
    } else {
      console.log(content)
      this.set_token(content.token)
    }

    console.log(">>>>> BUS RET :",url, content);
    return content;
  }




  async api(url: string, obj: any) {
    console.log("Bus.api", url, "calls:",Bus.calls)

    obj.token=this.get_token();
    //if (!obj.token && url!= "/api/user/login") this.fire("login_needed")
    obj.changed_by = this.get_user() ? this.get_user().data_username : ""
    obj.changed_date = new Date()
    const body:string = JSON.stringify(obj)


    console.log(">>>>> BUS API:",this.BASE+url)
    Bus.lock()
    const rawResponse = await fetch(this.BASE+url, {    method: "POST",   headers: {  Accept: "application/json", "Content-Type": "application/json"  },    body: body    });
    Bus.unlock()

  
    if (rawResponse.status >= 400) {
      console.error(">>>>> BUS ERR :",url, "HTTP Status > 400")
      throw "Bład API"
    }

    const ret:any = await rawResponse.json(); //
    //console.log("ret",ret)

    if (ret.login_err) {
      console.error("UNAUTHORIZED")
      this.on_method_call_timeout()
      return undefined;
    }
 
   
    if (!ret._err) {
      
//      console.log("!ret._err")
      if (url!= "/api/user/login") { 
        const content=ret.obj
        delete content.token;
        delete obj.token;
       
        //console.log("A")
        //console.log(">>>>> BUS API RET :",url, content);
       

        return content;
      } else {
        //console.log("B")
        this.set_token(ret.token)
        this.set_user(ret.user)
        this.on_login(ret.user)
      }
  
      
  
    } else {
      console.error(">>>>> BUS API ERR :", url, ret._err.title)

      if (ret._err.obj) {
        console.error(JSON.parse(ret._err.obj).stack)
        throw new Error("XYZ")
      }
      if (ret._err) {
        throw ret._err
      }
      
      return undefined;
    }

  }

  static _logged_in=false


  get_logged_in() {

      const ret= (window.localStorage.getItem("logged_in")=="true")
      Bus._logged_in = ret
      this.log("get logged_in="+Bus._logged_in+'..'+window.localStorage.getItem("logged_in"))
      return Bus._logged_in
  }

  set_logged_in(l:boolean) {
    Bus._logged_in = l
    this.log("set logged_in="+Bus._logged_in)
    window.localStorage.setItem("logged_in", Bus._logged_in.toString())
 }

  log(txt:string) {
      console.log("************** LOGIN MANAGER ",txt)
  }

  public async login(pd: IPasswordData): Promise<IUserWithToken | undefined> {
      this.log("login as "+ pd.idn)
      const user = await this.api(user_api.login, pd);
      return user;
  }

  async logout() {
      this.log("logout")
      this.set_token("");
      await this.api("/api/test",{a:"a"})
  }

  async on_login(user:any) {
      this.log("on login")
      window.localStorage.setItem("user",JSON.stringify(user))
      await this.set_logged_in( true );
      this.fire("on_login", user)
  }


  async on_logout() {
      this.log("on logout")
      window.localStorage.setItem("user","")
      await this.set_logged_in( false );
      this.fire("on_logout",{})
  }

  async on_method_call_timeout() {
      this.log("on_method_call_timeout")
      await this.set_logged_in( false );
      this.fire("on_logout",{})
  }


}
